import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { catchError, map } from "rxjs/operators";
import { HttpParams } from '@angular/common/http';
import { IShowcases } from '../interfaces/showcases';
import { IShowcase } from '../interfaces/showcase';

@Injectable({
  providedIn: 'root'
})
export class ShowcaseService {

  constructor(private _apiService: ApiService) {

  }

  list() : Observable<IShowcases>  {
    return this._apiService.doGET('showcase')
      .pipe(catchError(err => {
      return observableThrowError(err.error_message)
    }))
  }

  show(id: number) : Observable<IShowcase>  {
    return this._apiService.doGET('showcase/'+id)
      .pipe(catchError(err => {
      return observableThrowError(err.error_message)
    }))
  }

  store(data) : Observable<any> {
    return this._apiService.doPOST('showcase', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  patch(idvitrine, data) : Observable<any> {
    return this._apiService.doPATCH('showcase/'+idvitrine, data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  patchOrdem(data) : Observable<any> {
    return this._apiService.doPATCH('showcase/ordem', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  delete(idvitrine) : Observable<any> {
    return this._apiService.doDELETE('showcase/'+idvitrine)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  removeImage(idvitrine, capa) : Observable<any> {
    return this._apiService.doDELETE('showcase/'+idvitrine+'/image/'+capa)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  removeBanner(idvitrine, capa) : Observable<any> {
    return this._apiService.doDELETE('showcase/'+idvitrine+'/banner/'+capa)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

}
